// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMatchViewContext from '../../hooks/useMatchViewContext';
import useMergeProps from '../../hooks/useMergeProps';

import MatchHotBetGroups from './MatchHotBetGroups';
import makeMatchHotGroupsPropsSelector from './MatchHotBetGroups.selector';

type MatchHotGroupsContainerProps = {
  className?: string;
};

const MatchHotGroupsContainer = (ownProps: MatchHotGroupsContainerProps) => {
  const { matchId } = useMatchViewContext();

  const selectorProps = useMemo(
    () => ({
      matchId,
      isHotFilterSelected: true,
    }),
    [matchId],
  );
  const selector = useMemo(() => makeMatchHotGroupsPropsSelector(), []);
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const { outcomesData } = selectedProps;

  const enhancedProps = useMergeProps({
    ownProps,
    selectedProps,
  });

  return outcomesData?.length ? <MatchHotBetGroups {...enhancedProps} /> : null;
};

export default MatchHotGroupsContainer;
